<script setup>
import axios from "axios";
import { ref, onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import { useAuthStore } from "@/store/auth";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import FullScreenLoader from "@/components/FullScreenLoader.vue";
import HeaderHome from "./components/HeaderHome.vue";
import { loaderState, showLoader, hideLoader } from "../utils/loader/loader.js";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
const authStore = useAuthStore();
const iframeUrl = ref(null);

const getLink = async () => {
  showLoader();
  const result = await authStore.powerBi(localStorage.getItem("idmandato"));
  if (result.ok) {
    iframeUrl.value = result.resultado.linkpbi;
    await getReport();
  } else {
    toast.error(result.message);
  }
  hideLoader();
};

const getReport = async () => {
  const resquest = { identificador: localStorage.getItem("idmandato") };
  const token = localStorage.getItem("token");
  try {
    const { data } = await axios.post(
      "https://miportal.afcoma.com.mx/v1/SA/onedrive/vistageneral/getreports",
      resquest,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": "cls[ty-5JDrkzE1HFN9v",
        },
      }
    );
    authStore.listReport = data.result;
    console.log('data: ', data);
  } catch (error) {
    console.log("error: ", error);
  }
};

onMounted(async () => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
  await getLink();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="container-fluid">
      <header-home></header-home>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <p class="text-uppercase text-sm">Información del mandato</p>
              <div class="row">
                <div class="col-12">
                  <div class="iframe-container">
                    <iframe
                      :src="iframeUrl"
                      frameborder="0"
                      allowfullscreen
                      class="responsive-iframe"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <full-screen-loader :isVisible="loaderState.isVisible" />
  </main>
</template>
<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  .responsive-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
